import { render, staticRenderFns } from "./work-order-instructions.html?vue&type=template&id=082f671e&scoped=true&"
import script from "./work-order-instructions.js?vue&type=script&lang=js&"
export * from "./work-order-instructions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f671e",
  null
  
)

export default component.exports